//@ts-expect-error
//@ts-nocheck
import React, { Fragment, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import useHostname from '../components/Provider/HostnameProvider';
import Layout from '../components/Layout/Layout';

import ActionBtn from '../components/Button/ActionBtn';
import SecSlideStep from '../components/Sections/SecSlideStep';
import { ChartStepIcon, InfoStepIcon, MCardIcon, XCardIcon } from '../components/svg/Svg';
import AccordionHelp from '../components/Accordion/AccordionHelp';
import SecGetApp from '../components/Sections/SecGetApp';
// If you have a custom header that should appear on every page, import it here
// import Header from '../components/Header';

const SeeHowItWorks = () => {
  const originalUrl = useHostname();

  // UI Hover States
  const [activeIndex, setActiveIndex] = useState(1);
  const handleMouseEnter = (index) => {
    setActiveIndex(index);
  };

  const [activeChartIndex, setActiveChartIndex] = useState(1);
  const handleChartMouseEnter = (index) => {
    setActiveChartIndex(index);
  };

  const [activePhoneIndex, setActivePhoneIndex] = useState(1);
  const handlePhoneMouseEnter = (index) => {
    setActivePhoneIndex(index);
  };

  return (
    <Fragment>
      <Layout title='FuteurAI' description='Futeur AI'>

        {/**
         * SECTION 1: Hero
         * -----------------------------------------------------
         * - Removed absolute positioning on the phone mockup
         * - Split content into two columns so text never overlaps image.
         * - Maintains consistent styling (pt-16 sm:pt-24 md:pt-32, px-4, etc.)
         */}
        <section className="relative pt-16 sm:pt-24 md:pt-32 bg-white overflow-hidden">
          <Container className='px-4 sm:px-6 lg:px-8 mt-[3rem]'>
            <Row className="align-items-center">
              {/* LEFT COLUMN: HEADINGS, TEXT, BUTTONS */}
              <Col md={6}>
                <h1 className='font-bold text-black text-3xl sm:text-4xl md:text-5xl lg:text-6xl xl:text-[80px] leading-relaxed mb-4 sm:mb-6'>
                  FuteurAI – The Future of Business Credit Starts Here
                </h1>

                <p className='text__18 text-black mb-4 leading-relaxed'>
                  Small businesses drive America, yet banking apps fail your greatest asset—business credit.  
                  FuteurAI changes everything, making credit visible, actionable, and accessible anywhere. 
                  Empower your business today, for tomorrow’s opportunities.
                </p>
                <p className='text__18 text-black mb-4 leading-relaxed'>
                  Your business. Your credit. Your future. FuteurAI is how you take control.
                </p>

                <div className="flex flex-wrap gap-4 mb-5">
                  
                                    <ActionBtn 
                                      link="/vision" 
                                       title="Explore the Vision →"
                                    />
                                     <ActionBtn 
                                      link="https://app.futeur.ai/signup" 
                                      title="Unlock Your Credit Now →"  
                                    />
                </div>

                {/** 
                 * If you still want a different image for *mobile only*, 
                 * you can keep the conditional .sm:hidden block below 
                 */}
                <div className='sm:hidden'>
                  <img 
                    src={"/mockups/handmockup.png"}
                    className='rounded-[24px] w-full h-auto'
                    alt="Mobile Mockup"
                  />
                </div>
              </Col>

              {/* RIGHT COLUMN: HAND/PHONE MOCKUP */}
              <Col md={6} className="text-center sm:text-right mt-5 mt-md-0">
                {/* This mockup will only show at sm+ breakpoints */}
                <div className='hidden sm:block'>
                  <img
                    src={"/mockups/handmockup.png"}
                    className='w-auto h-auto max-w-[450px] ml-auto'
                    alt="Hand Mockup"
                  />
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        {/**
         * SECTION 2: Gap in Business Banking Apps
         * -----------------------------------------------------
         */}
        <section className='py-12 sm:py-16 bg-black text-white relative overflow-hidden'>
          <Container className='px-4 sm:px-6 lg:px-8'>
            <h2 className='font-medium text-3xl sm:text-4xl md:text-5xl mb-6 sm:mb-8 text-center'>
              Your Favorite Banking App – Only Shows Personal Credit
            </h2>

            {/* Explanation Container */}
            <div 
              className="p-4 sm:p-6 mb-8 rounded-[32px] bg-[rgba(46,46,46,0.32)]"
              onMouseEnter={() => handlePhoneMouseEnter(2)}
              onMouseLeave={() => handlePhoneMouseEnter(1)}
            >
              <h5 className='font-medium text-2xl sm:text-3xl mb-6 text-center'>
                The Gap in Business Banking Apps
              </h5>
              <p className='text__18 text-white/80 leading-relaxed text-center mb-[2rem]'>
                Your banking app makes personal credit easy—tools like CreditWise or Chase Credit Journey 
                show your score right next to your accounts. But here’s the problem: if you’re a business owner, 
                your business credit score is nowhere to be found.
              </p>
            </div>

            {/* Two-Column Cards */}
            <Row className='gap-y-4'>
              {/* Card 1 */}
              <Col lg={6}>
                <div 
                  className="p-6 sm:p-8 rounded-[32px] bg-[rgba(46,46,46,0.32)] relative overflow-hidden"
                  onMouseEnter={() => handleMouseEnter(2)}
                  onMouseLeave={() => handleMouseEnter(1)}
                >
                  <h4 className='font-medium text-lg sm:text-xl text-white mb-2'>
                    Personal Credit is Easy to Monitor.
                  </h4>
                  <p className='text__18 leading-relaxed text-white/60'>
                    Apps like CreditWise and Chase Credit Journey show your personal credit score. 
                    Hit 700+, and doors open to credit cards, home loans, and car leases—making 
                    financial freedom feel within reach.
                  </p>
                  <div className="mt-[2.5rem] flex items-center justify-center">
                    <img 
                      src={"/mockups/SHIWMockup1.png"} 
                      alt="Personal Credit Mockup"
                      className='rounded-[24px]' 
                    />
                  </div>
                </div>
              </Col>

              {/* Card 2 */}
              <Col lg={6}>
                <div 
                  className="p-6 sm:p-8 rounded-[32px] bg-[rgba(46,46,46,0.32)] relative overflow-hidden"
                  onMouseEnter={() => handleChartMouseEnter(2)}
                  onMouseLeave={() => handleChartMouseEnter(1)}
                >
                  <h4 className='font-medium text-lg sm:text-xl text-white mb-2'>
                    Business Credit is Invisible.
                  </h4>
                  <p className='text__18 leading-relaxed text-white/60'>
                    Ever opened your business banking app looking for your business credit score? You won’t find it. 
                    Your balances are there, but the business credit health that decides your business loans and leases? Missing.
                  </p>
                  <div className="mt-[2.5rem] flex items-center justify-center">
                    <img 
                      src={"/mockups/SHIWMockup2.png"} 
                      alt="Business Credit Mockup"
                      className='rounded-[24px]'
                    />
                  </div>
                </div>
              </Col>
            </Row>
            <div className="flex items-center justify-center mt-8">
            <ActionBtn
                 link="/credit-comparsion"
                 title="Learn More"
                 variant={2} // Orange button variant
                size="normal"
        />
        </div>
          </Container>
        </section>

        {/**
         * SECTION 3: FuteurAI – Redefining Small Business Credit
         * -----------------------------------------------------
         */}
        <section className='py-12 sm:py-16 bg-white'>
          <Container className='px-4 sm:px-6 lg:px-8'>
            <div className="w-full bg-Mneutral100 rounded-[24px] sm:rounded-[56px] p-6 sm:p-8 lg:p-12">
            <Row className='gap-y-4'>
                <Col md={6} className='my-auto'>
                <video
                  src="/WebApp.mp4"
                  className="rounded-[20px] w-full h-auto mb-10 object-cover"
                  autoPlay
                  loop
                  muted
                  playsInline
                />
                </Col>
                <Col md={6} className='my-auto'>
                <h4 className='font-bold text-black text-center text-3xl sm:text-4xl md:text-4xl mb-3'> FuteurAI WebApp</h4>
                  <h4 className='font-medium text-black text-center text-3xl sm:text-4xl md:text-3xl mb-3'>
                    Instant Credit Insights Without the Hassle
                  </h4>
                  <h5 className='text__18 leading-relaxed text-black font-bold mb-2'> Why wait for clarity when you can have it now?</h5>
                  <p className='text__18 leading-relaxed text-Mneutral700 mb-4'>
                 The FuteurAI WebApp is designed for immediate, app-free access to your business credit reports. Optimized for Safari, Chrome, and Firefox, it transforms your mobile browser into a powerful business tool.
                 
                  </p>
                  <h5 className='text__18 leading-relaxed text-black font-bold mb-2'> No Downloads, No Delays</h5>
                  <p className='text__18 leading-relaxed text-Mneutral700 text-bold mb-4'>Open your browser, log in, and access detailed credit reports in seconds.</p>
                  <h5 className='text__18 leading-relaxed text-black font-bold mb-2'>On-the-Go Intelligence</h5>
                  <p className='text__18 leading-relaxed text-Mneutral700 mb-4'>Whether you’re between meetings or planning your next step, the webapp gives you the insights you need, when you need them.</p>

                  <div className="flex space-x-4">
                    <ActionBtn link="https://app.futeur.ai/signup" title="Explore Now" />
                    <ActionBtn link="/SeeSample" title="See Samples" />
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </section>

        {/**
         * SECTION 4: Empowering America’s Small Businesses
         */}
<section className="py-12 sm:py-16 bg-white relative">
  <Container className="px-4 sm:px-6 lg:px-5">
    <div className="w-full bg-Mneutral100 rounded-[24px] sm:rounded-[56px] p-6 sm:p-8 lg:p-12 relative z-10">
      <Row className="gap-y-8 lg:gap-y-4">
        <Col md={6} xs={12} className="my-auto">
          <div className="relative">
            <video
              src="/MobileVideo.mp4"
              className="rounded-[20px] w-full h-auto object-cover sm:absolute sm:-top-16 sm:left-1/2 sm:transform sm:-translate-x-1/2 lg:-top-24 lg:w-[120%]"
              autoPlay
              loop
              muted
              playsInline
            />
          </div>
        </Col>
        <Col md={6} xs={12} className="my-auto">
          <h4 className="font-bold text-black text-center text-2xl sm:text-3xl md:text-4xl mb-3">
            FuteurCred Mobile App
          </h4>
          <h4 className="font-medium text-black text-center text-xl sm:text-2xl md:text-3xl mb-3">
            The Credit Karma for Business Credit
          </h4>
          <p className="text__16 sm:text__18 leading-relaxed text-Mneutral700 mb-4">
            Manage your business credit with confidence, precision, and ease—right from your pocket. The FuteurAI Mobile App delivers a Credit Karma-like experience tailored for businesses. It’s your personal credit advisor, empowering you to monitor, manage, and maximize your credit potential.
          </p>
          <h5 className="text__16 sm:text__18 leading-relaxed text-black font-bold mb-2">
            Intuitive Dashboard
          </h5>
          <p className="text__16 sm:text__18 leading-relaxed text-Mneutral700 mb-4">
            Track your credit health, monitor changes, and receive actionable recommendations instantly.
          </p>
          <h5 className="text__16 sm:text__18 leading-relaxed text-black font-bold mb-2">
            Tailored Alerts
          </h5>
          <p className="text__16 sm:text__18 leading-relaxed text-Mneutral700 mb-4">
            Stay informed with real-time updates that keep you ahead.
          </p>
          <h5 className="text__16 sm:text__18 leading-relaxed text-black font-bold mb-2">
            Growth-Oriented Tools
          </h5>
          <p className="text__16 sm:text__18 leading-relaxed text-Mneutral700 mb-4">
            Understand what impacts your score and get clear steps to improve it.
          </p>
          <h4 className="font-bold text-black text-center text-xl sm:text-2xl md:text-3xl mb-3">
            Coming Soon
          </h4>
        </Col>
      </Row>
    </div>
  </Container>
</section>

        {/**
         * (Optional) SECTION 5: Slide Steps or Additional Feature Highlights
        
        <section className='py-12 sm:py-16 bg-white'>
          <Container className='px-4 sm:px-6 lg:px-8'>
            <SecSlideStep />
          </Container>
        </section>
 */}
        {/**
         * SECTION 6: Help / FAQ
         */}
<section className="py-4 sm:py-8 md:py-12">
  <div className="px-4 sm:px-6 md:px-8 lg:px-12">
    <div
      className="
        w-full
        lg:px-4
        xl:px-[2.5rem]
        py-8 lg:py-16
        bg-Mneutral100
        rounded-2xl
        sm:rounded-[56px]
        text-black
        shadow-md
      "
    >
      <Container>
        <Row className="gap-y-4">
          {/* Left Column */}
          <Col md={5}>
            <h2
              className="
                text-[2rem]
                sm:text-[2.5rem]
                md:text-[3rem]
                font-medium
                mb-10 md:mb-8
              "
            >
              Do you need ⎯ <br />
              some help?
            </h2>
            <div
              className="
                w-full
                bg-Mneutral900
                p-4
                rounded-2xl
                text-white
              "
            >
              <h5
                className="
                  font-medium
                  text-lg
                  sm:text-xl
                  mb-6
                "
              >
                Didn't find the answer you were looking for? Our support team is
                here to help!
              </h5>
              <ActionBtn
                link="/contact"
                title="Contact us"
                size="medium"
                variant={3}
              />
            </div>
          </Col>

          {/* Right Column */}
          <Col md={7}>
            <div className="flex flex-wrap gap-y-3">
              {[
                {
                  title:
                    "How Does FuteurCred Help Me Access Business Credit Reports Instantly?",
                  desc: "FuteurCred eliminates the need for apps or complicated setups. Simply open your browser on Safari, Chrome, or Firefox, log in to our webapp, and get detailed business credit insights in seconds—anytime, anywhere.",
                },
                {
                  title:
                    "What Makes the FuteurCred Mobile App Different From Other Credit Platforms?",
                  desc: "Our mobile app is designed specifically for businesses. Think of it as the “Credit Karma for business credit”—providing intuitive dashboards, personalized recommendations, and real-time alerts to help you monitor, manage, and improve your business credit like never before.",
                },
                {
                  title: "Do I Need to Download an App to Use FuteurCred?",
                  desc: "Not at all! FuteurCred’s webapp is fully optimized for mobile browsers, delivering an app-free experience that gives you instant access to your credit reports without taking up space on your device.",
                },
                {
                  title:
                    "How Does FuteurCred Ensure the Accuracy of My Business Credit Reports?",
                  desc: "We integrate with trusted business credit bureaus to provide up-to-date and reliable data. Our platform also offers tools to identify discrepancies and actionable insights to improve your credit profile.",
                },
                {
                  title:
                    "Can FuteurCred Help Me Understand How My Business Credit Score Is Calculated?",
                  desc: "Absolutely! Our platform breaks down the factors affecting your business credit score—like payment history, credit utilization, and public records—so you can take proactive steps to improve your financial health.",
                },
              ].map((obj, index) => (
                <Fragment key={index}>
                  <AccordionHelp title={obj.title} desc={obj.desc} />
                  {/* Divider line */}
                  <div className="w-full h-[1px] bg-Mneutral200"></div>
                </Fragment>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  </div>
</section>

        {/**
         * SECTION 7: Get the App or Final CTA
        
        <SecGetApp />
         */}
      </Layout>
    </Fragment>
  );
};

export default SeeHowItWorks;

